import { now } from "@messages/timing";
import { ROOM_TRANSITION_FADE_DURATION_MS } from "@messages/rendering/RoomTransitionMessages";
const TRANSITION_CLEAR_COLOR = 0x05326e;
class RoomTransitionLoadingState {
    constructor() {
        this.prewarmSettledForTransition = false;
        this.isLoading = false;
        this.phase = "inactive";
        this.phaseStartedAt = 0;
    }
    beginTransition(roomUid) {
        this.transitionRoomUid = roomUid;
        this.activeRoomUid = roomUid;
        this.prewarmSettledForTransition = false;
        this.startFadeIn(roomUid);
    }
    markRoomEntered(roomUid) {
        this.transitionRoomUid = roomUid;
        this.prewarmSettledForTransition = false;
    }
    beginWaitingForPrewarm(roomUid) {
        const transitionAlreadyStarted = this.transitionRoomUid === roomUid && this.isLoading;
        if (this.transitionRoomUid !== roomUid) {
            this.transitionRoomUid = roomUid;
            this.prewarmSettledForTransition = false;
        }
        this.activeRoomUid = roomUid;
        if (transitionAlreadyStarted)
            return;
        this.startFadeIn(roomUid);
    }
    startFadeIn(roomUid) {
        this.phase = "fade-in";
        this.phaseStartedAt = now();
        this.isLoading = true;
        console.log(`[prewarm] fade in -> room=${String(roomUid)}`);
    }
    markPrewarmSkipped(roomUid) {
        if (this.transitionRoomUid === roomUid) {
            this.prewarmSettledForTransition = true;
        }
        if (this.activeRoomUid !== roomUid)
            return;
        this.updatePhase();
    }
    markPrewarmDone(roomUid) {
        if (this.transitionRoomUid === roomUid) {
            this.prewarmSettledForTransition = true;
        }
        if (this.activeRoomUid !== roomUid)
            return;
        this.updatePhase();
    }
    isActive() {
        this.updatePhase();
        return this.isLoading;
    }
    getClearColor() {
        return TRANSITION_CLEAR_COLOR;
    }
    getClearAlpha() {
        this.updatePhase();
        const elapsed = now() - this.phaseStartedAt;
        switch (this.phase) {
            case "fade-in":
                return Math.min(1, elapsed / ROOM_TRANSITION_FADE_DURATION_MS);
            case "hold":
                return 1;
            case "fade-out":
                return Math.max(0, 1 - elapsed / ROOM_TRANSITION_FADE_DURATION_MS);
            default:
                return 0;
        }
    }
    updatePhase() {
        while (this.isLoading) {
            const elapsed = now() - this.phaseStartedAt;
            if (this.phase === "fade-in") {
                if (elapsed < ROOM_TRANSITION_FADE_DURATION_MS)
                    return;
                this.phaseStartedAt += ROOM_TRANSITION_FADE_DURATION_MS;
                this.phase = this.prewarmSettledForTransition ? "fade-out" : "hold";
                continue;
            }
            if (this.phase === "hold") {
                if (!this.prewarmSettledForTransition)
                    return;
                this.phase = "fade-out";
                this.phaseStartedAt = now();
                continue;
            }
            if (this.phase === "fade-out" && elapsed >= ROOM_TRANSITION_FADE_DURATION_MS) {
                this.phase = "inactive";
                this.isLoading = false;
                console.log(`[prewarm] fade out -> room=${String(this.activeRoomUid)}`);
            }
            return;
        }
    }
}
export const roomTransitionLoadingState = new RoomTransitionLoadingState();
